import { useEffect, useState, useCallback, useMemo } from "react";
import { Grid } from "@material-ui/core";
import { useStyles } from "../../../clientes/components/clientes-list/clientes-list-styles";
import { Paginacao } from "views/components/paginacao";
import { CircularLoading } from "views/components/utils/circular-loading/circular-loading";
import { useCadastros, useSessaoAtual, useToastSaurus } from "services/app";
import { PessoasModel } from "model/api/gestao/pessoa/pessoas-model";
import { useGetPessoa } from "data/api/gestao/pessoa";
import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas";
import { useHistory, useLocation } from "react-router-dom";
import { ButtonFab } from "views/components/controles";
import { MenuVerticalIcon, NovoIcon } from "views/components/icons";
import { ApiListModel } from "model/api/gestao/api-list-model/api-list-model";
import { ClientesListData } from "views/pages/private/clientes/components/clientes-list/clientes-list-data";
import { RevendedorListSearchProps } from "views/pages/private/revendedor/components/revendedor-list/revendedor-list-search-props";
import { useGetPessoaExportarExcel } from "data/api/gestao/pessoa/get-pessoa-exportar-excel";
import { isEmpty } from "lodash";
import { useThemeQueries } from "views/theme";
import { ButtonFabMenu } from "views/components/controles/buttons/button-fab-menu";
import { ExportarExcelIcon } from "views/components/icons/exportar-excel-icon";
import { ButtonFabMenuModel } from "model/app/components/button-fab-menu/button-fab-menu";
import { useDefaultCadastroStyles } from "views/pages/private/cadastros/components/default-cadastro-styles";

interface RepresentantesListProps {
  searchProps: RevendedorListSearchProps
}

export const RepresentantesList = ({ searchProps }: RepresentantesListProps) => {
  const classes = useStyles();
  const listClasses = useDefaultCadastroStyles();
  const { isMobile } = useThemeQueries();

  const { getPessoa, carregando: carregandoGet } = useGetPessoa();
  const { getPessoaExportarExcel, carregando: carregandoExcel } = useGetPessoaExportarExcel();


  const { tipoUsuario } = useSessaoAtual()

  const { showToast } = useToastSaurus();
  const history = useHistory()
  const location = useLocation();
  const { abrirCadastroRepresentantes, cadastroRepresentantesState } = useCadastros()

  const carregando = carregandoExcel || carregandoGet

  const [queryStatus, setQueryStatus] = useState<ApiListModel<PessoasModel>>({
    pageIndex: 1,
    totalPages: 0,
    totalResults: 0,
    pageSize: 0,
    list: Array<PessoasModel>(),
  });

  const [selectedList, setSelectedList] = useState<Array<string>>([]);
  const [openMenu, setOpenMenu] = useState<boolean>(false);

  const handleOpen = useCallback(() => {
    setOpenMenu(true);
  }, [])

  const handleClose = useCallback(() => {
    setOpenMenu(false);
  }, [])

  const fillResult = useCallback(
    async (
      page: number,
      totalPages: number,
      totalResults: number,
      list: Array<PessoasModel>
    ) => {
      setQueryStatus({
        pageIndex: page,
        list: list,
        totalResults: totalResults,
        totalPages: totalPages,
        pageSize: 0
      });
    },
    []
  );
  const search = useCallback(
    async (newPage: number) => {
      try {
        const query = `pageSize=30&TipoPessoa=${EnumTipoPessoas.Representante}&query=${searchProps.termo}`
        const res = await getPessoa(newPage, query);
        if (res.erro) throw res.erro;

        if (res.resultado?.data === undefined) {
          return
        }

        //se o index for maior que as paginas ele busca a ultima
        if (
          res.resultado?.data.pageIndex > res.resultado?.data.totalPages &&
          res.resultado?.data.totalResults > 0
        ) {
          search(res.resultado.data.totalPages);
          return;
        }

        fillResult(
          res.resultado?.data.pageIndex,
          res.resultado?.data.totalPages,
          res.resultado?.data.totalResults,
          res.resultado?.data.list
        );

        return res;
      } catch (e: any) {
        showToast("error", e.message);
      }
    },
    [searchProps.termo, getPessoa, fillResult, showToast]
  );

  const pageChanged = useCallback(
    async (newPage: number) => {
      if (newPage <= queryStatus.totalPages || newPage > 0) {
        search(newPage);
      }
    },
    [search, queryStatus.totalPages]
  );

  const onCardSelected = (id: string) => {
    history.push({
      pathname: `/representantes/${id}`,
      state: {
        from: {
          pathname: history.location.pathname,
          page: queryStatus.pageIndex
        }
      }
    });
  };

  const onCardChecked = (id: string) => {
    const aux = [...selectedList];
    aux.push(id);
    setSelectedList(aux);
  };

  useEffect(() => {
    let page = Number(new URLSearchParams(location.search).get('page'));
    if (!cadastroRepresentantesState.aberto) {
      search(page || queryStatus.pageIndex);
    }
    location.search = ''
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, cadastroRepresentantesState, searchProps]);

  const exportExcel = useCallback(async (newPage: number) => {
    const query =
      (!isEmpty(searchProps.termo)
        ? '&query=' + searchProps.termo
        : '') + `&tipoPessoa=${EnumTipoPessoas.Representante}`

    try {
      const res = await getPessoaExportarExcel(newPage, query)
      if (res.erro) throw (res.erro)
      if (!res.resultado) return;

      const blob = new Blob([res.resultado?.data], { type: 'application/vnd.ms-excel' });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a')

      anchor.href = url
      anchor.download = `Representantes-${new Date().toLocaleDateString().replaceAll('/', '-')}.xls`
      anchor.click()

    } catch (e: any) {
      showToast('error', e.message);
    }
  }, [getPessoaExportarExcel, searchProps.termo, showToast])

  const onClickMenuItem = useMemo(() => {
    const itens = new Array<ButtonFabMenuModel>();

    itens.push(new ButtonFabMenuModel(<ExportarExcelIcon tipo='BUTTON_FAB' />, 'Exportar Excel', () => exportExcel(1)))

    return itens;
  }, [exportExcel])

  const isSoftwarehouse = ([EnumTipoPessoas.SoftwareHouse, EnumTipoPessoas.FinanceiroSoftwareHouse, EnumTipoPessoas.FinanceiroSoftwareHouseSemCusto].includes(tipoUsuario()))

  return (
    <>
      <Grid className={classes.list}>
        <div className={classes.defaultContainer}>
          {carregando && <CircularLoading tipo="FULLSIZED" />}
          <Grid container className={listClasses.listContainer}>
            <Grid item xs={12}>
              <Paginacao
                pageChanged={pageChanged}
                totalPages={queryStatus.totalPages}
                totalRegisters={queryStatus.totalResults}
                currentPage={queryStatus.pageIndex}
                exportarExcel={() => exportExcel(1)}
              />
            </Grid>
            <Grid item xs={12} className={classes.listContainer}>
              <ClientesListData
                carregando={carregando}
                list={queryStatus.list}
                selectedList={selectedList}
                onCardSelected={onCardSelected}
                onCardChecked={onCardChecked}
                label='Representante'
                tooltipMessage="Editar Representante"
                emptyMessage="Nenhum Representante Vinculado"
              />
            </Grid>
          </Grid>
        </div>
      </Grid>
      {isSoftwarehouse && (
        <>
          {isMobile ? (
            <>
              {carregando ? <CircularLoading tipo="FULLSIZED" /> : null}
              <ButtonFabMenu
                open={openMenu}
                onOpen={handleOpen}
                onClose={handleClose}
                values={onClickMenuItem}
                icon={<MenuVerticalIcon tipo='BUTTON_FAB' />}
                style={{
                  zIndex: 0,
                }}
              />
            </>
          ) : (
            <ButtonFab
              tooltip="Novo Representante"
              icon={<NovoIcon tipo="BUTTON_FAB" />}
              onClick={() => abrirCadastroRepresentantes('', false)}
            />
          )}
        </>
      )}
    </>
  );
};